export default function getMinListLength() {
  if (process.env.REACT_APP_LIST_MIN_LENGTH) {
    return parseInt(process.env.REACT_APP_LIST_MIN_LENGTH, 10);
  }
  return 4;
}
